import { Button } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

export const BarArea = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const Card = styled.div`
  background-color: var(--color-bg-weak);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  margin-top: var(--size-16);
  padding: var(--size-padding-16);
`;

export const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const ChartDescriptionArea = styled.div`
  flex: 1;
`;

export const DescriptionPercentArea = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 14px;
`;

export const DotDescription = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 8px;

  :before {
    background: ${props => props.color};
    border-radius: var(--size-border-radius-circle); //
    content: '';
    display: inline-flex;
    height: 16px;
    margin-right: 8px;
    position: relative;
    width: 16px;
  }
`;

export const Rate = styled.div`
  font-weight: bold;
  text-align: right;
  width: 73px;
`;

export const RecipientCount = styled.div`
  margin-left: 16px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;

  & > .card-wrapper {
    flex: 1;
  }
`;

export const ThankYouNotes = styled.div`
  border: 1px solid var(--color-neutral-50);
  border-radius: var(--size-border-radius-md);
  padding: var(--size-padding-16);
  width: 50vw;
`;

export const ThankYouNotesTitleWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: flex-start;

  ${Button.S.Button} {
    color: var(--color-components-button-primary-text-fg);
  }
`;
